import tmhRequest from '@/config/tmhRequest'

export default {

    searchListOpenPlatformStore: function (data) {
        return tmhRequest({
            url: '/system/tmh/openplatformstore/searchlistopenplatformstore',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/system/openplatformstore.js